import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useT } from "@reciperoll/core";

// Section title with an optional leading icon (shown in terracotta, before the
// title) + optional uppercase eyebrow + "See all" link — mirrors the RN
// SectionHeader.
export function SectionHeader({
  title,
  icon,
  eyebrow,
  link,
  linkText,
}: {
  title: string;
  icon?: ReactNode;
  eyebrow?: string;
  link?: string;
  linkText?: string;
}) {
  const t = useT();
  return (
    <div className="flex items-start justify-between mb-4">
      <div>
        {eyebrow && (
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-terracotta-ink mb-1.5">
            {eyebrow}
          </p>
        )}
        <div className="flex items-center gap-2">
          {icon && <span className="shrink-0 text-terracotta">{icon}</span>}
          <h2 className="font-display text-2xl font-semibold tracking-tight text-ink">{title}</h2>
        </div>
      </div>
      {link && (
        <Link
          to={link}
          className="shrink-0 text-sm font-semibold text-terracotta-ink hover:text-terracotta-dark"
        >
          {linkText ?? t("home.seeAll")}
        </Link>
      )}
    </div>
  );
}
